// DF-0566 — le libellé d'une fermeture complète la phrase « Fermé pour … jusqu'au … ».
// Un patron qui y écrit une phrase entière (« Fermé – ouverture le 20 octobre ») la
// verrait doublée : un libellé qui commence déjà par un mot de fermeture ou
// d'ouverture est affiché tel quel. Même règle, recopiée, dans ignite-owner et
// ignite-admin ($lib/types/closures.ts) pour l'aperçu du formulaire.
const SENTENCE_START =
  /^(ferm|clos|cl[oô]t|ouvert|r[ée]ouvert|open|reopen|休|暂停|停业|闭店|关门|开业|营业|歇业|放假|مغلق)/i;

export function closureLabelIsSentence(label: string): boolean {
  return SENTENCE_START.test(label.trim());
}

// SC-1581 — un congé posé en deux fois dans le calendrier (le 20, puis du 21 au 23)
// est stocké en deux plages accolées. Le bandeau annonçait la fin de la première
// (« jusqu'au 20 octobre ») : la vraie fin est celle de la dernière plage qui
// touche ou chevauche la précédente. Même règle, recopiée, dans ignite-owner et
// ignite-admin ($lib/types/closures.ts) pour l'aperçu du formulaire.
function nextIsoDay(iso: string): string {
  const [y, m, d] = iso.split('-').map(Number);
  return new Date(Date.UTC(y, m - 1, d + 1)).toISOString().slice(0, 10);
}

export function closureRunEnd(closures: { from: string; to: string }[], to: string): string {
  let end = to;
  for (;;) {
    const limit = nextIsoDay(end);
    const longer = closures.find(
      (c) => typeof c?.from === 'string' && typeof c?.to === 'string' && c.from <= limit && c.to > end,
    );
    if (!longer) return end;
    end = longer.to;
  }
}
